import { render, staticRenderFns } from "./ModalTKO.vue?vue&type=template&id=7290ffc8&"
import script from "./ModalTKO.vue?vue&type=script&lang=js&"
export * from "./ModalTKO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports